module.exports = __webpack_public_path__ + "img/guancaigy.633a3dd0.jpg";